export const MISSING_OR_INVALID_TOKEN = "We're sorry, but this survey does not appear to be valid. Please contact your innerlogic administrator for additional information or help if this issue persists."
export const ERROR_ON_SUBMISSION = "There was error in the submition please try again!"
export const THANKYOU_MESSAGE = {
    EN: 'Thank you for contributing',
    FR: 'Merci pour votre réponse au sondage',
    ES: 'Gracias por contribuir'
}